const ASSET_URL = 'https://assets.vouchedfor.co.uk/img/';
export const LogoWhite = ASSET_URL + 'vf2023/logo-white.png';

export const dmIcon = ASSET_URL + 'vf2023/home/Daily_Mail_Logo_Navy.png';
export const guardianIcon = ASSET_URL + 'vf2023/home/The_Guardian_Logo_Navy.png';
export const independentIcon = ASSET_URL + 'vf2023/home/Independent_Logo_Navy.png';
export const itvIcon = ASSET_URL + 'vf2023/home/ITV_Logo_Navy.png';
export const sundaytimesIcon = ASSET_URL + 'vf2023/home/The_Sunday_Times_Navy.png';
export const timIcon = ASSET_URL + 'home/tim-w.png';
